import { useEffect } from 'react';

const MetaTags = ({ title, description, url, image, type = 'article' }) => {
    useEffect(() => {
        // Set document title
        if (title) {
            document.title = title;
        }

        // Helper function to set or update meta tag
        const setMetaTag = (property, content, isProperty = true) => {
            if (!content) return;

            const attribute = isProperty ? 'property' : 'name';
            let element = document.querySelector(`meta[${attribute}="${property}"]`);

            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, property);
                document.head.appendChild(element);
            }

            element.setAttribute('content', content);
        };

        // Helper function to set canonical link tag
        const setCanonicalTag = (canonicalUrl) => {
            if (!canonicalUrl) return;

            let canonicalLink = document.querySelector('link[rel="canonical"]');
            if (!canonicalLink) {
                canonicalLink = document.createElement('link');
                canonicalLink.setAttribute('rel', 'canonical');
                document.head.appendChild(canonicalLink);
            }
            canonicalLink.setAttribute('href', canonicalUrl);
        };

        // Set canonical URL
        setCanonicalTag(url);

        // Set standard meta tags
        setMetaTag('description', description, false);

        // Set Open Graph meta tags
        setMetaTag('og:type', type);
        setMetaTag('og:url', url);
        setMetaTag('og:title', title);
        setMetaTag('og:description', description);
        setMetaTag('og:image', image);
        setMetaTag('og:site_name', 'Melbourne Nepalese Community West');

        // Set Twitter Card meta tags
        setMetaTag('twitter:card', 'summary_large_image', false);
        setMetaTag('twitter:url', url, false);
        setMetaTag('twitter:title', title, false);
        setMetaTag('twitter:description', description, false);
        setMetaTag('twitter:image', image, false);

        // Cleanup function to restore default title on unmount
        return () => {
            document.title = 'Melbourne Nepalese Community West';
        };
    }, [title, description, url, image, type]);

    return null; // This component doesn't render anything
};

export default MetaTags;
